import React, { Component } from "react";

/** Matches admin ECAS Form A social cognition Part A (Content.js) object → quadrant. */
const PART_A_FAVORITE_TO_SLOT = {
  1: { cow: 1, mosquito: 2, koala: 3, lion: 4 },
  2: { guava: 1, apple: 2, pineapple: 3, banana: 4 },
  3: { tablelamp: 1, cupboard: 2, bed: 3, studytable: 4 },
  4: { cat: 1, bird: 2, giraffe: 3, horse: 4 },
  5: { tomato: 1, cauliflower: 2, onion: 3, eggplant: 4 },
  6: { truck: 1, train: 2, plane: 3, cycle: 4 },
};

function normalizeFavoriteKey(value) {
  if (value === null || value === undefined || value === "" || value === false) {
    return "";
  }
  return String(value).trim().toLowerCase().replace(/\s+/g, "");
}

function partASlotFromFavorite(trial, favorite) {
  const key = normalizeFavoriteKey(favorite);
  if (!key) return null;
  const map = PART_A_FAVORITE_TO_SLOT[trial];
  if (!map) return null;
  return map[key] ?? null;
}

function partASelectedSlot(trial, statuspa, favorite) {
  if (statuspa !== null && statuspa !== undefined && statuspa !== "") {
    const n = parseInt(String(statuspa).trim(), 10);
    if (!Number.isNaN(n) && n >= 1 && n <= 4) return n;
  }
  return partASlotFromFavorite(trial, favorite);
}

function partAOptionSelected(trial, statuspa, favorite, option) {
  return partASelectedSlot(trial, statuspa, favorite) === option;
}

export default class SocialCongPartA extends Component {
  render() {
    var {
      social_congnition_statuspa1,
      social_congnition_statuspa2,
      social_congnition_statuspa3,
      social_congnition_statuspa4,
      social_congnition_statuspa5,
      social_congnition_statuspa6,
      social_congnition_a1_faverite_object,
      social_congnition_a2_faverite_object,
      social_congnition_a3_faverite_object,
      social_congnition_a4_faverite_object,
      social_congnition_a5_faverite_object,
      social_congnition_a6_faverite_object,
    } = this.props.data;
    return (
      <div className="row border border-dark social_cognition_a_section">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                1){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(1, social_congnition_statuspa1, social_congnition_a1_faverite_object, 1)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/1/1.png`}
                        alt="social r 1"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(1, social_congnition_statuspa1, social_congnition_a1_faverite_object, 2)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/1/2.png`}
                        alt="social r 2"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(1, social_congnition_statuspa1, social_congnition_a1_faverite_object, 3)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/1/3.png`}
                        alt="social r 3"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(1, social_congnition_statuspa1, social_congnition_a1_faverite_object, 4)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/1/4.png`}
                        alt="social r 4"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                2){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(2, social_congnition_statuspa2, social_congnition_a2_faverite_object, 1)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/2/1.png`}
                        alt="s c 21"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(2, social_congnition_statuspa2, social_congnition_a2_faverite_object, 2)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/2/2.png`}
                        alt="s c 22"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(2, social_congnition_statuspa2, social_congnition_a2_faverite_object, 3)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/2/3.png`}
                        alt="s c 23"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(2, social_congnition_statuspa2, social_congnition_a2_faverite_object, 4)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/2/4.png`}
                        alt="s c 24"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                3){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(3, social_congnition_statuspa3, social_congnition_a3_faverite_object, 1)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/3/1.png`}
                        alt="s c 21"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(3, social_congnition_statuspa3, social_congnition_a3_faverite_object, 2)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/3/2.png`}
                        alt="s c 22"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(3, social_congnition_statuspa3, social_congnition_a3_faverite_object, 3)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/3/3.png`}
                        alt="s c 23"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(3, social_congnition_statuspa3, social_congnition_a3_faverite_object, 4)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/3/4.png`}
                        alt="s c 24"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                4){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(4, social_congnition_statuspa4, social_congnition_a4_faverite_object, 1)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/4/1.png`}
                        alt="s c 21"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(4, social_congnition_statuspa4, social_congnition_a4_faverite_object, 2)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/4/2.png`}
                        alt="s c 22"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(4, social_congnition_statuspa4, social_congnition_a4_faverite_object, 3)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/4/3.png`}
                        alt="s c 23"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(4, social_congnition_statuspa4, social_congnition_a4_faverite_object, 4)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/4/4.png`}
                        alt="s c 24"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                5){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(5, social_congnition_statuspa5, social_congnition_a5_faverite_object, 1)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/5/1.png`}
                        alt="s c 21"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(5, social_congnition_statuspa5, social_congnition_a5_faverite_object, 2)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/5/2.png`}
                        alt="s c 22"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(5, social_congnition_statuspa5, social_congnition_a5_faverite_object, 3)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/5/3.png`}
                        alt="s c 23"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(5, social_congnition_statuspa5, social_congnition_a5_faverite_object, 4)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/5/4.png`}
                        alt="s c 24"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                6){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(6, social_congnition_statuspa6, social_congnition_a6_faverite_object, 1)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/6/1.png`}
                        alt="s c 21"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(6, social_congnition_statuspa6, social_congnition_a6_faverite_object, 2)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/6/2.png`}
                        alt="s c 22"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(6, social_congnition_statuspa6, social_congnition_a6_faverite_object, 3)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/6/3.png`}
                        alt="s c 23"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        partAOptionSelected(6, social_congnition_statuspa6, social_congnition_a6_faverite_object, 4)
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={`${process.env.PUBLIC_URL || ""}/assets/images/ecas/social-cognition-part-a/6/4.png`}
                        alt="s c 24"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div
          className="col-lg-2 pt-4"
          style={{ borderLeft: "1px solid #000" }}
        ></div>
      </div>
    );
  }
}
